module.exports = __webpack_public_path__ + "img/local-scenic-spot.0dc2f451.png";